module.exports = __webpack_public_path__ + "static/media/certik.png:Zone.d41d8cd9.Identifier";